// Global error handler to prevent errors from showing in the browser

// Set up global error handling
const setupGlobalErrorHandling = () => {
  // Handle runtime errors
  window.addEventListener('error', (event) => {
    console.error('Runtime error caught by global handler:', event.error);
    // Prevent the error from showing in the console
    event.preventDefault();
    return true;
  });

  // Handle promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection caught by global handler:', event.reason);
    // Prevent the rejection from showing in the console
    event.preventDefault();
    return true;
  });

  // Override console.error to filter out React-specific errors in production
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Filter out certain React errors that shouldn't be shown to users
    const errorString = args.join(' ');
    const shouldSuppressError = 
      errorString.includes('Warning:') || 
      errorString.includes('React will try to recreate this component tree') ||
      errorString.includes('Invalid prop');

    if (!shouldSuppressError) {
      originalConsoleError.apply(console, args);
    }
  };
};

export default setupGlobalErrorHandling;
